import React, { useEffect, useState } from 'react'
import InputForm from '../../../../components/InputForm'
import SelectionForm from '../../../../components/SelectionForm'
import CheckIco from '../../../../components/icons/CheckIco'
import SpinnerText from '../../../../components/SpinnerText'
import { getFormattedDates, translateDatePicker } from '../../../utils'
import { createDashboard, updateDashboard, getOrganizationUsersForSharing } from '../../../../services/apiProcessDashboards'
import { useAppContext } from '../../../../providers/AppContext'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../../../providers/AuthContext'
import Spinner from '../../../../components/Spinner'
import Toggle from '../../../../components/forms/Toggle'
import SelectableList from '../../../../components/SelectableList'
import { useDashboards } from '../../../../providers/DashboardContext'

function DashboardForm({dashboard, toggle, refreshList, module}) {
  const {addToast} = useAppContext();
  const { sDashboard = dashboard , refreshCurrentDashboard } = useDashboards()
  const {auth} = useAuth();
  const navigate = useNavigate();
  const [dateOptions, setDateOptions] = useState(getFormattedDates(new Date()));
  const [dataRange, setDataRange] = useState('Hoy');
  const [formError, setFormError] = useState({field: "", error: ""});
  const [form, setForm] = useState();
  const [isTabulated, setIsTabulated] = useState(false);
  const [tabList, setTabList] = useState("") 
  // Dashboard personal: solo lo ve quien lo crea, salvo que se lo comparta
  // explícitamente con otros usuarios de la misma organización.
  const [isPersonal, setIsPersonal] = useState(false);
  const [orgUsers, setOrgUsers] = useState(null);
  const [fetchingOrgUsers, setFetchingOrgUsers] = useState(false);
  const [sharedWithUsernames, setSharedWithUsernames] = useState([]);
  // Si el dashboard es personal y NO soy quien lo creó (isOwner viene
  // calculado desde el backend), significa que me lo compartieron: no debo
  // poder tocar el toggle ni la lista de compartidos, solo ver que está
  // activado y quién me lo compartió.
  const isSharedWithMe = !!(dashboard && dashboard.isPersonal && dashboard.isOwner === false);
  //banderas backend
  const [updating, setUpdating] = useState(false);
  const [fetching, setFeching ] = useState(true);

  const handleNameChange = (name) => {
    let tempForm = {...form}
    tempForm.name = name.trim();
    setForm({...tempForm});
  }
  const handleDateFormatChange = (dateFormat) => {
    let tempForm = {...form}
    tempForm.dateFormat = dateFormat;
    setForm({...tempForm});
  }
  const handleDataRangeChange = (selectedRange) => {
    setDataRange(translateDatePicker(selectedRange))
    //guardar form
    let tempForm = {...form}
    console.log(selectedRange)
    tempForm.dateRange = selectedRange
    setForm({...tempForm})
  }
  const handleTabulateDashboard = (tabulated) => {
    setIsTabulated(tabulated);
    let tempForm = {...form}
    tempForm.isTabulated = tabulated;
    setForm({...tempForm});
  }

  const handleTabList = (commaList) => {
    let separatedList = commaList.split(",");
    let tempForm = {...form}
    tempForm.tabList = separatedList;
    setForm({...tempForm});
  }

  // Trae los usuarios de mi organización para elegir con quién compartir.
  // `preselectedIds` son los ids ya guardados en el dashboard (al editar
  // uno existente) - se usan para armar la selección inicial de la lista
  // en términos de username, que es lo que maneja SelectableList.
  const refreshOrgUsers = (preselectedIds = []) => {
    async function fetchUsers() {
      return await getOrganizationUsersForSharing(auth?.token);
    }
    try {
      setFetchingOrgUsers(true);
      fetchUsers().then(response => {
        setOrgUsers(response);
        const preselectedUsernames = response
          .filter(u => preselectedIds.includes(u._id))
          .map(u => u.username);
        setSharedWithUsernames(preselectedUsernames);
        setFetchingOrgUsers(false);
      }).catch(error => {
        console.log(error);
        addToast("No se pudo cargar la lista de usuarios de la organización", 2);
        setFetchingOrgUsers(false);
      });
    } catch (error) {
      console.log(error);
      setFetchingOrgUsers(false);
    }
  }

  const handleTogglePersonal = (personal) => {
    setIsPersonal(personal);
    let tempForm = {...form}
    tempForm.isPersonal = personal;
    if (!personal) {
      // Al destildar no se pierde nada guardado hasta ahora: se limpia acá
      // y también en el backend por las dudas, para que no quede una
      // lista vieja de compartidos si se vuelve a marcar más adelante.
      tempForm.sharedWithUserIds = [];
      setSharedWithUsernames([]);
    } else if (!orgUsers) {
      refreshOrgUsers(form?.sharedWithUserIds || []);
    }
    setForm({...tempForm});
  }

  const handleSharedUsersChange = (selectedUsernames) => {
    const usernames = selectedUsernames || [];
    setSharedWithUsernames(usernames);
    const ids = usernames
      .map(username => orgUsers?.find(u => u.username === username)?._id)
      .filter(Boolean);
    let tempForm = {...form}
    tempForm.sharedWithUserIds = ids;
    setForm({...tempForm});
  }

  const handleAddDashboard = ()=>{
    async function doAdd(){
      let dashboardToSave;
      if (dashboard){
        dashboardToSave = await updateDashboard(
          form,
        auth?.token);
      }else{
        dashboardToSave = await createDashboard(
          form,
        auth?.token);
      }
      return dashboardToSave;
    }
    try{
      setFormError({field: "", error: ""})
      setUpdating(true);
      doAdd().then(response => {
        if (sDashboard?._id === form._id){
          refreshCurrentDashboard();
        }
        setUpdating(false);
        addToast(dashboard ? 'Dashboard actualizado' : 'Dashboard agregado' , 0);
        refreshList();
        toggle();
      }).catch(error => {
        setUpdating(false);
        if ([400].includes(error?.response?.status)){
          let errorData = error.response.data
          if (errorData && errorData.field && errorData.error){
            let tempError = {...formError}
            tempError.field =  errorData.field
            tempError.error =  errorData.error
            setFormError(tempError);
          }
          
        }
        if ([404].includes(error?.response?.status)){
          addToast("Dashboard no encontrado",2)
          toggle();
        }
        if ([419].includes(error?.response?.status)){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        if ([500].includes(error?.response?.status)){
          addToast('Ocurrió un error al crear dashboard ' , 3);
        } 
        console.log(error)
      })
    }
    catch( error) {
      console.log(error);
      setUpdating(false);
      addToast('Ocurrió un error inesperado, intente nuevamente' , 3);
    }
  }

  useEffect( () => {
    if (dashboard){
      setForm({
        _id: dashboard._id,
        name: dashboard.name,
        dateFormat: dashboard.dateFormat,
        dateRange: dashboard.dateRange,
        isTabulated: dashboard.isTabulated,
        tabList: dashboard.tabList,
        module: dashboard.module,
        isPersonal: dashboard.isPersonal || false,
        sharedWithUserIds: dashboard.sharedWithUserIds || []
      });
      setDataRange(translateDatePicker(dashboard.dateRange))
      setTabList(dashboard.tabList ? dashboard.tabList.join(",") :  "");
      setIsTabulated(dashboard.isTabulated)
      setIsPersonal(dashboard.isPersonal || false)
      if (dashboard.isPersonal && dashboard.isOwner !== false) {
        refreshOrgUsers(dashboard.sharedWithUserIds || []);
      }
      setFeching(false);
    }else{
      setForm(
        {
          name: "",
          dateFormat: "mm/dd/yy - hh:mm",
          dateRange: {  
            activeTab: 'customDates',
            selectedRange: 'today',
            startDate: new Date(),
            endDate: new Date()
          },
          isTabulated: false,
          tabList: [  ],
          module: module,
          isPersonal: false,
          sharedWithUserIds: []
        }
      )
      setIsPersonal(false)
      setSharedWithUsernames([])
      setFeching(false);
    }
    console.log(dashboard)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboard])
  return (
    <div className='flex flex-col justify-between'>
      
      { !fetching && (
        <>
          <div className='flex flex-col mb-32'>
            <InputForm text={"Nombre"} value={form.name} onChange={event => handleNameChange(event.target.value)}/>
            {/*<DataRangePicker onChange={(event) => console.log(event)}/>*/}
            <SelectionForm 
              text="Formato de fecha" 
              options={Object.keys(dateOptions)} 
              mask={dateOptions} 
              value={form.dateFormat}
              onChange={event => handleDateFormatChange(event)} />
            <InputForm 
              type={"datarange"} 
              text={"Rango de tiempo predeterminado"} 
              value={dataRange} 
              AppendClassName='text-left' 
              onChange={(event) => handleDataRangeChange(event)}
              dateRangeOptions={form.dateRange} 
            />
            <div className='w-full flex mt-2 mb-2'>
              <Toggle 
                label={"Dashboard tabulado"}
                initialValue={form.isTabulated}
                handleChange={handleTabulateDashboard}
                enable={!dashboard}
                
              />
            </div>
            {isTabulated && (
              <InputForm text={"Tabs, Separados por coma"} 
                value={form.tabList} 
                onChange={event => handleTabList(event.target.value)}
                enabled={!dashboard}
              />
            )}
            <div className='w-full flex mt-2 mb-2'>
              <Toggle 
                label={"Dashboard personal"}
                initialValue={form.isPersonal}
                handleChange={handleTogglePersonal}
                enable={!isSharedWithMe}
              />
            </div>
            {isPersonal && isSharedWithMe && (
              <div className='w-full mb-4 border border-gray-200 rounded-md p-3'>
                <span className='text-sm text-gray-500'>
                  Este dashboard es compartido por {dashboard?.creatorUsername || "otro usuario"}.
                </span>
              </div>
            )}
            {isPersonal && !isSharedWithMe && (
              <div className='w-full mb-4 border border-gray-200 rounded-md p-3'>
                <span className='text-sm text-gray-500'>
                  Compartir con:
                </span>
                {fetchingOrgUsers && (
                  <div className='flex justify-center py-2'>
                    <Spinner />
                  </div>
                )}
                {!fetchingOrgUsers && orgUsers && orgUsers.length === 0 && (
                  <span className='block text-sm text-gray-400 py-2'>No hay otros usuarios en tu organización</span>
                )}
                {!fetchingOrgUsers && orgUsers && orgUsers.length > 0 && (
                  <div className='max-h-40 overflow-y-auto'>
                    <SelectableList
                      items={orgUsers.map(u => u.username)}
                      multiSelect={true}
                      selection={sharedWithUsernames}
                      setItems={handleSharedUsersChange}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
          <div className='w-full flex justify-end'>
            {updating && (
              <div>
                <SpinnerText text={"Guardando..."}/>
              </div>
              
            )}
            {!updating && (
              <button className='' onClick={() => handleAddDashboard()}>
                <CheckIco width='50px' height='50px'/>
              </button>
            )}
          </div>
        </>
      ) }
      { fetching && (
        <div className='flex flex-col mb-32'>
          <Spinner />
        </div>
       
      )}
      
    </div>
  )
}

export default DashboardForm